Ext.define('SA.ProjectViewContainmentObserver', {
    singleton: true,

    initialize() {
        this.observable = new Ext.util.Observable();

        SA.Viewport.on('resize', this.fireChange, this);
        SA.Sidebar.on('resize', this.fireChange, this);
        SA.ViewChooser.on('resize', this.fireChange, this);
    },

    fireChange() {
        this.observable.fireEvent('change');
    },

    setListener(method, scope) {
        this.observable.clearListeners();
        this.observable.on('change', method, scope);
    }
});